<app-cerrix-slide-out [isOpen]="isOpen" (isOpenChange)="requestClose()">
    <div class="sidebar">
        <div class="sidebar-title">{{ title }}</div>
        @for (item of items.items; track $index) {
            <button
                class="section-item"
                [attr.data-uiid]="'slide-out-section-' + item.id"
                [class.active]="item.id === items.activeItem"
                (click)="openSection(item.id)"
            >
                {{ item.name }}
            </button>
        }
    </div>
    <div class="slide-out-main">
        <ng-content></ng-content>
    </div>
</app-cerrix-slide-out>

<cerrix-confirm-dialog
    [name]="unsavedChangesDialogName"
    dataUiid="slide-out-edit-item-unsaved-changes-confirm"
    icon="warning"
    [title]="'unsavedChangesDialogTitle' | t"
    [description]="'unsavedChangesDialogDescription' | t"
    [cancelText]="'unsavedChangesDialogCancelText' | t"
    [confirmText]="'unsavedChangesDialogConfirmText' | t"
    (cancel)="discardAndLeave()"
    (confirm)="saveAndLeave()"
    class="dialog-unsaved-changes-confirm"
>
</cerrix-confirm-dialog>
